import React, { useCallback, useState, useEffect } from 'react';
import Modal from '../../../ControlPanel/components/modal/Modal';
import { Box, DialogActions, DialogContent, Typography, Button, Dialog, MobileStepper, IconButton } from '@mui/material';
import { setOpenModal } from '../../store/authSlice';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { updateUserIsFirstLogin } from '../../store/authThunks';
import './WelcomeModal.css';
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

import { useGuidedTour } from "../../../MediaControls/components/guidedTour/GuidedTourContext";

import { GuidedTourProvider } from "../../../MediaControls/components/guidedTour/GuidedTourContext";
import GuidedTooltip from "../../../MediaControls/components/guidedTour/GuidedTooltip";

const WELCOME_MODAL_SEEN_KEY = 'welcomeModalSeen';
const setWelcomeModalSeen = () => {
  localStorage.setItem(WELCOME_MODAL_SEEN_KEY, 'true');
};

function useMobile() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);

    // Nettoyage
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return isMobile;
}


function TourStarter() {
  const { start } = useGuidedTour();

  useEffect(() => {
    start();
  }, []); // s'exécute une seule fois au montage
  return <GuidedTooltip />;
}


export default function WelcomeModal() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { openModal, localAvatar } = useSelector(state => state.auth);
  const modalPayload = openModal?.payload;
  
  const [showTour, setShowTour] = useState(false);


  const handleCloseCard = useCallback(() => {
    setWelcomeModalSeen();
    dispatch(setOpenModal(null));
    if (localAvatar.is_first_login === true) {
      dispatch(updateUserIsFirstLogin({}));
    }

  }, [dispatch])

  const isMobile = useMobile();
  const [activeStep, setActiveStep] = useState(0);

  const steps = [
    {
      img: "/move.gif",
      title: t("Move"),
      desc: t("click_seats_to_move_avatar"),
      className: ""
    },
    {
      img: "/micro&camera.gif",
      title: t("mic_and_camera"),
      desc: t("toggle_mic_camera"),
      className: ""
    },
    {
      img: "/discuter.gif",
      title: t("chat_title"),
      desc: t("chat_description"),
      className: "discuter"
    }
  ];

  const maxSteps = steps.length;

  const handleNext = () => {
    setActiveStep((prev) =>
      prev === maxSteps - 1 ? 0 : prev + 1
    );
  };

  const handleBack = () => {
    setActiveStep((prev) =>
      prev === 0 ? maxSteps - 1 : prev - 1
    );
  };

  return (
    <>
      {openModal === "welcome" && localAvatar.is_first_login === false && (
        <Dialog
          open={true}
          onClose={handleCloseCard}
          maxWidth="md"
          PaperProps={{
            sx: {
              borderRadius: "1rem",
              padding: "1.5rem",
              textAlign: "center",
              backgroundColor: "#fff",
              position: "relative",
            },
          }}
        >
          <DialogContent sx={{ mt: 2, mb: 4 }}>
            {/* Logo */}
            <Box mb={2}>
              <img
                src="/Aifel.svg"
                alt="Logo"
                style={{ width: 86, height: 74 }}
              />
            </Box>

            {/* Titre */}
            <Typography variant="h5" fontWeight="bold" mb={2} sx={{
              color: 'var(--Grey-modern-Example, #0C0C0C)',

              fontFamily: 'Poppins',
              fontSize: 20,
              fontStyle: 'normal',
              fontWeight: 700,
              lineHeight: 'normal',
            }}>
              {t("Bienvenue-sur-PeoplMap")}
            </Typography>

            {/* Description */}
            <Typography variant="body1" color="textSecondary" mb={3} sx={{
              color: 'var(--Grey-modern-Example, #364152)',

              fontFamily: 'Satoshi',
              fontSize: 20,
              fontStyle: 'normal',
              fontWeight: '500',
              lineHeight: 'normal',
            }}>
              {t(
                "text-welcome"
              )}
              <br />
              {t("Enjoy")}
            </Typography>
          </DialogContent>

          <DialogActions sx={{ justifyContent: "center" }}>
            <Button
              onClick={handleCloseCard}
              sx={{
                color: "#000000ff",
                borderRadius: "0.5rem",
                backgroundColor: "var(--peoplmap-primary)",
                padding: "0.6875rem 1.375rem",
                textTransform: "none",
                '&:hover': {
                  backgroundColor: "#53c03d",
                },
              }}
            >
              {t("got_it")}
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {((openModal === "welcome" && localAvatar.is_first_login === true) || (modalPayload?.source === "info_support")) && (
        <Dialog
          open={true}
          onClose={handleCloseCard}
          maxWidth="md"
          PaperProps={{
            sx: {
              borderRadius: "1rem",
              padding: "1.5rem",
              textAlign: "center",
              backgroundColor: "#fff",
              position: "relative",
            },
          }}
        >
          <DialogContent sx={{ mt: 2, mb: 4 }}>
            {/* Logo */}
            <Box mb={2}>
              <img
                src="/Aifel.svg"
                alt="Logo"
                style={{ width: 86, height: 74 }}
              />
            </Box>

            {/* Titre */}
            <Typography variant="h5" fontWeight="bold" mb={2} sx={{
              color: 'var(--Grey-modern-Example, #0C0C0C)',

              fontFamily: 'Poppins',
              fontSize: 20,
              fontStyle: 'normal',
              fontWeight: 700,
              lineHeight: 'normal',
            }}>
              {t("Bienvenue-sur-PeoplMap")}
            </Typography>

            {/* Description */}
            <Typography variant="body1" color="textSecondary" mb={3} sx={{
              color: 'var(--Grey-modern-Example, #364152)',

              fontFamily: 'Satoshi',
              fontSize: 14,
              fontStyle: 'normal',
              fontWeight: '500',
              lineHeight: 'normal',
            }}>
              {t(
                "text-welcome_new"
              )}
            </Typography>


            {!isMobile && (
              <Box display="flex" justifyContent="space-between" gap={2}>
                {steps.map((step, index) => (
                  <Box key={index} flex={1} className="box">
                    <Box className="image-wrapper">
                      <img
                        src={step.img}
                        alt={step.title}
                        className={`image-wlc ${step.className}`}
                      />
                    </Box>

                    <Typography fontWeight="bold" mb={1} sx={{ textAlign: "center" }}>
                      {step.title}
                    </Typography>

                    <Typography variant="body2" sx={{ textAlign: "center" }}>
                      {step.desc}
                    </Typography>
                  </Box>
                ))}
              </Box>
            )}

            {isMobile && (
              <>
                <Box className="box">
                  <IconButton
                    onClick={handleBack}
                    sx={{
                      position: "absolute",
                      left: 10,
                      top: "50%",
                      transform: "translateY(-50%)",
                      backgroundColor: "#fff",
                      boxShadow: 1,
                      "&:hover": { backgroundColor: "#f5f5f5" },
                    }}
                  >
                    <ArrowBackIosNewIcon fontSize="small" />
                  </IconButton>
                  <Box className="image-wrapper">
                    <img
                      src={steps[activeStep].img}
                      alt={steps[activeStep].title}
                      className={`image-wlc ${steps[activeStep].className}`}
                    />
                  </Box>

                  <Typography fontWeight="bold" mb={1} sx={{ textAlign: "center" }}>
                    {steps[activeStep].title}
                  </Typography>

                  <Typography variant="body2" sx={{ textAlign: "center" }}>
                    {steps[activeStep].desc}
                  </Typography>

                  <IconButton
                    onClick={handleNext}
                    sx={{
                      position: "absolute",
                      right: 10,
                      top: "50%",
                      transform: "translateY(-50%)",
                      backgroundColor: "#fff",
                      boxShadow: 1,
                      "&:hover": { backgroundColor: "#f5f5f5" },
                    }}
                  >
                    <ArrowForwardIosIcon fontSize="small" />
                  </IconButton>
                </Box>

                {/* Bullets */}
                <MobileStepper
                  variant="dots"
                  steps={steps.length}
                  position="static"
                  activeStep={activeStep}
                  sx={{
                    justifyContent: "center",
                    mt: 2,
                    background: "transparent",
                  }}
                  nextButton={null}
                  backButton={null}
                />
              </>
            )}
          </DialogContent>

          <DialogActions sx={{ justifyContent: "center", flexWrap: "wrap", display:"flex", gap:"1.5625rem" }}>
            <Button
              onClick={handleCloseCard}
              sx={{
                color: "#479A32",
                borderRadius: "0.5rem",
                border: "1px solid #D8D8D8",
                backgroundColor: "#fff",
                padding: "0.5rem 0.9375rem",
                textTransform: "none",
                display:"flex",
                height:"100%",
                width:"15.625rem",
                
                fontWeight:"600",
                fontSize:"0.875rem",
                
                '&:hover': {
                  backgroundColor: "#53c03d",
                  color: "#fff",
                },
              }}
            >
              {t("got_it_start_aifel")}
            </Button>
            <Button
              onClick={() => {
                handleCloseCard();
                setShowTour(false);         // démonte le Provider
                setTimeout(() => {
                  setShowTour(true);        // re-monte proprement
                }, 0);
              }}
              sx={{
                color: "#fff",
                borderRadius: "0.5rem",
                backgroundColor: "#479A32",
                padding: "0.5rem 0.9375rem",
                textTransform: "none",
                border: "1px solid #D8D8D8",
                height:"100%",
                width:"15.625rem",
                
                fontWeight:"600",
                fontSize:"0.875rem",


                '&:hover': {
                  backgroundColor: "#53c03d",
                },
              }}
            >
              {t("use_tutorial")}
            </Button>
          </DialogActions>
        </Dialog>
      )}

    {showTour && (
      <GuidedTourProvider>
        <TourStarter />
      </GuidedTourProvider>
    )}

    </>
  )
}

